
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personality_test/[result_slug]",
      function () {
        return require("private-next-pages/personality_test/[result_slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personality_test/[result_slug]"])
      });
    }
  